import ol = require("ol");
import _ = require("underscore");
import Utils = require("../utils");
import Base = require("./base-command");
import Converter = require("../utils/ol3/converter");

// trigger when cursor is over a feature
class Command extends Base<{}> {

    static about = `Listens for map "pointermove" event and triggers an event with "selected" and "unselected" features.`;

    static options = {
        "delay": {
            about: "Debounce delay, in milliseconds, before invoking the pointermove callback.",
            default: "100"
        }
    }

    execute(args = this.args) {

        let debounceInterval = parseInt(this.options["delay"]);

        this.mediator.mapViewMap(map => {

            let converter = new Converter(map.getView().getProjection().getCode());

            let features = <Array<Rhythm.GIS.FeatureQueryResultFeature>>[];

            let mouseMoveHandler = _.debounce((evt: { coordinate: ol.Coordinate }) => {
                let priorFeatures = features;

                let layers = map.getLayers().getArray()
                    .filter(l => l instanceof ol.layer.Vector)
                    .map(l => <ol.layer.Vector>l);

                layers.some(l => {
                    let s = l.getSource();
                    features = converter.fromNativeFeatures(s.getFeaturesAtCoordinate(evt.coordinate)).features;
                    return !!features.length;
                });

                let eventArgs = {
                    selected: features,
                    unselected: priorFeatures.filter(pf => !features.some(f => this.mediator.extend(f).olFeature === this.mediator.extend(pf).olFeature))
                };

                // share results via trigger
                this.trigger(eventArgs);
            }, debounceInterval, false);

            map.on("pointermove", mouseMoveHandler);

        });
    }

}

export = Command;